





















































import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { DashboardWidgetHeaderColor } from '../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../types/enums/dashboard-widget-value-color';
import ActiveDealsWidget from '../widgets/components/ActiveDealsWidget.vue';
import AverageDealTimeWidget from '../widgets/average-deal-time/components/AverageDealTimeWidget.vue';
import EstimatedSalesWidget from '../widgets/components/EstimatedSalesWidget.vue';
import ExpiredDealsWidget from '../widgets/components/ExpiredDealsWidget.vue';
import HitRateWidget from '../widgets/hit-rate/components/HitRateWidget.vue';
import HotDealsWidget from '../widgets/components/HotDealsWidget.vue';
import ValleyOfDeathWidget from '../widgets/components/ValleyOfDeathWidget.vue';
import WonDealsWidget from '../widgets/components/WonDealsWidget.vue';
import LatestActivitiesWidget from '../widgets/latest-activity/components/LatestActivitiesWidget.vue';
import TopPerformersWidget from '../widgets/top-performers/components/TopPerformersWidget.vue';

export default defineComponent({
  components: {
    ActiveDealsWidget,
    HitRateWidget,
    WonDealsWidget,
    HotDealsWidget,
    ValleyOfDeathWidget,
    ExpiredDealsWidget,
    EstimatedSalesWidget,
    AverageDealTimeWidget,
    LatestActivitiesWidget,
    TopPerformersWidget,
  },
  props: {
    currency: {
      type: Object as PropType<Currency>,
      required: true,
    },
    showAll: {
      type: Boolean,
    },
  },
  setup() {
    return {
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
    };
  },
});
